import { Pipe, PipeTransform, } from '@angular/core';
import { ObjectMap, Utilities, } from '@socrates/common';

@Pipe({
	name: 'arrayContains',
	standalone: false,
})
export class ArrayContainsPipe implements PipeTransform {

	private objectMap: ObjectMap = new ObjectMap();

	transform(list: any, args): any {

		let result: any = list;

		if (args.validSet && Array.isArray(args.validSet) && args.validSet.length > 0 && args.propName && Array.isArray(list) && list.length > 0) {
			result = list.filter(
				(val: any) => {
					const testVal: any = this.objectMap.getValue(val, args.propName);
					const found = args.validSet.find(
						(validValue) => {
							return testVal === validValue;
						}
					);
					const contained = Utilities.hasValidValue(found);
					return args.reverse ? !contained : contained;
				}
			);
		}
		return result;
	}
}
